<pf-dropdown [hideArrow]="true" class="user-menu">
    <div slot="head">
        <a class="nav-link">
            <pf-image
                src="../../../../../assets/img/default-profile.png"
                fallbackSrc="assets/img/default-profile.png"
                class="user-image-small"
                width="25"
                height="25"
                alt="User Image"
                rounded="true"
            />
        </a>
    </div>
    <div slot="body">
        <li class="user-header bg-primary">
            <pf-image
                fallbackSrc="assets/img/default-profile.png"
                class="user-image-big"
                alt="User Image"
                width="90"
                height="90"
                rounded="true"
            />

            <p>
                {{ user?.email }}
                <small>
                    <span class="fw-bolder">{{this.userType}} </span>

                    <span *ngIf="user?.metadata?.creationTime">
                        {{ formatDate(user?.metadata?.creationTime) }}
                    </span>
                </small>
            </p>
        </li>
        <!-- Menu Body -->
        <!-- Menu Footer-->
        <li class="user-footer">
            <!-- <a [routerLink]="['/profile']" class="btn btn-default btn-flat">
                Profile
            </a> -->
            <a (click)="logout()" class="btn btn-default btn-flat float-right">
                Sign out
            </a>
        </li>
    </div>
</pf-dropdown>
